import { compose } from 'ramda';
import { useSelector } from 'react-redux';
import {
  BrowserRouter, Routes, Route, Navigate,
} from 'react-router-dom';
import { withTwnelContext } from '@twnel/web-components';
import { getDefaultCompany } from 'src/data/selectors';
import GlobalStyle from 'src/ui/util/GlobalStyle';

const withLightShell = (Component) => (props) => {
  const defaultCompany = useSelector(getDefaultCompany);
  /* eslint-disable react/jsx-props-no-spreading */
  return (
    <BrowserRouter>
      <GlobalStyle />
      <Routes>
        <Route path="/:id" element={<Component {...props} />} />
        <Route path="*" element={<Navigate to={`/${defaultCompany}`} replace />} />
      </Routes>
    </BrowserRouter>
  ); /* eslint-enable react/jsx-props-no-spreading */
};

const enhancedShell = compose(withTwnelContext, withLightShell);
export default enhancedShell;
